// src/components/Filter/FilterModuleRange.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useConfig } from '../../contexts/ConfigContext';

const FilterModuleRange = ({
    filterType,
    title,
    handleChange,
    selectedFilters,
    thcMin,
    prefix = '%',
}) => {
    const { menuFilter } = useConfig();
    const [minValue, setMinValue] = useState('');
    const [maxValue, setMaxValue] = useState('');
    const initialFilterApplied = useRef(false);

    useEffect(() => {
        let initialMin, initialMax;
        
        if (filterType === 'potencyThc') {
            initialMin = thcMin || String(selectedFilters[filterType]?.min ?? menuFilter[filterType]?.min ?? '');
            initialMax = String(selectedFilters[filterType]?.max ?? menuFilter[filterType]?.max ?? '');
        } else {
            initialMin = String(selectedFilters[filterType]?.min ?? menuFilter[filterType]?.min ?? '');
            initialMax = String(selectedFilters[filterType]?.max ?? menuFilter[filterType]?.max ?? '');
        }
        
        setMinValue(initialMin);
        setMaxValue(initialMax);
        
        // Apply the initial filter only once
        if (!initialFilterApplied.current && thcMin) {
            const updatedRange = {
                ...(initialMin ? { min: parseFloat(initialMin) } : {}),
                ...(initialMax ? { max: parseFloat(initialMax) } : {})
            };
            handleChange(updatedRange, filterType);
            initialFilterApplied.current = true;
        }
    }, [filterType, selectedFilters, menuFilter, thcMin]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const numValue = value === '' ? null : parseFloat(value);

        if (name === 'min') {
            setMinValue(value);
        } else {
            setMaxValue(value);
        }

        const updatedRange = {
            ...(name === 'min' ? { min: numValue } : {}),
            ...(name === 'max' ? { max: numValue } : {})
        };

        handleChange(updatedRange, filterType);
    };

    return (
        <div 
            className="filter-sidebar-num-range"
            role="group"
            aria-labelledby={`range-title-${filterType}`}
        >
            {title && (
                <label 
                    id={`range-title-${filterType}`}
                    htmlFor={`headless-range-slider-${filterType}`}
                >
                    {title}
                </label>
            )}
            <div className="filter-sidebar-num-range-input filter-sidebar-num-range-input-min">
                <div className="filter-sidebar-num-range-input-wrapper">
                    <span aria-hidden="true">{prefix}</span>
                    <input
                        type="number"
                        name="min"
                        id={`headless-range-slider-${filterType}-min`}
                        min={menuFilter[filterType]?.min ?? 0}
                        max={menuFilter[filterType]?.max ?? 100}
                        value={minValue}
                        onChange={handleInputChange}
                        aria-label={`Minimum ${title || filterType} value`}
                    />
                </div>
                <div className="filter-sidebar-num-range-input-label" aria-hidden="true">min</div>
            </div>
            <div className="filter-sidebar-num-range-input filter-sidebar-num-range-input-max">
                <div className="filter-sidebar-num-range-input-wrapper">
                    <span aria-hidden="true">{prefix}</span>
                    <input
                        type="number"
                        name="max"
                        id={`headless-range-slider-${filterType}-max`}
                        min={menuFilter[filterType]?.min ?? 0}
                        max={menuFilter[filterType]?.max ?? 100}
                        value={maxValue}
                        onChange={handleInputChange}
                        aria-label={`Maximum ${title || filterType} value`}
                    />
                </div>
                <div className="filter-sidebar-num-range-input-label" aria-hidden="true">max</div>
            </div>
        </div>
    );
};

export default FilterModuleRange;
